
import { RequestedValue$1 } from "../../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_OfPromise_either } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ApiReceiver_$reflection } from "../../../../Shared/User.js";
import { list_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../../ErrorHandling.js";
import { Cmd_none } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export function init() {
    return [new State(new RequestedValue$1(0, [])), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(ApiReceiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/receivers/api-receivers", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])))];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        return [state, Cmd_none()];
    }
    else {
        return [new State(new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
    }
}

